import { PageHero, CTABand } from "@/components/site/PageHero";
import { Container, Overline, Reveal } from "@/lib/ui";
import { LEADERSHIP, IMAGES } from "@/data/site";

export default function Leadership() {
  return (
    <>
      <PageHero
        id="leadership"
        overline="Leadership"
        title="Investors and operators, accountable to your objectives."
        lead="Our leadership brings together institutional investment discipline and hands-on operating experience across every major real estate asset class."
        image={IMAGES.meeting}
      />

      <section className="py-24 md:py-32 bg-[#F7F7F5]">
        <Container>
          <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
            {LEADERSHIP.map((l, i) => (
              <Reveal key={l.role} delay={(i % 2) * 0.08}>
                <div className="bg-white border border-[#E5E5DF] rounded-sm p-8 h-full flex gap-6">
                  <div className="shrink-0 w-16 h-16 rounded-full bg-[#1B3B2B] text-white font-display text-2xl flex items-center justify-center">
                    {l.name.charAt(0)}
                  </div>
                  <div>
                    <h3 className="font-display text-2xl text-[#121A16]">{l.name}</h3>
                    <div className="overline text-[#275C43] mt-1 mb-3">{l.role}</div>
                    <p className="text-[#5C6660] leading-relaxed">{l.bio}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <p className="mt-10 text-sm text-[#8A918B] max-w-2xl">
            Full executive biographies and additional team members are available on request.
          </p>
        </Container>
      </section>

      <CTABand />
    </>
  );
}
